import { render, staticRenderFns } from "./CompletedCampaignsTable.vue?vue&type=template&id=3c3aaf62&scoped=true"
import script from "./CompletedCampaignsTable.vue?vue&type=script&lang=ts"
export * from "./CompletedCampaignsTable.vue?vue&type=script&lang=ts"
import style0 from "./CompletedCampaignsTable.vue?vue&type=style&index=0&id=3c3aaf62&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aaf62",
  null
  
)

export default component.exports